/**
 * © [2020] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import moment from 'moment';
import { withRouter } from 'react-router';
import { isNaN } from 'lodash';
import DisplayErrorMessages from '../../../../SharedModules/Errors/ErrorMessages';
import EvenntLoggingForm from './EvenntLoggingForm';
import {
  dispatchServiceFailure,
  getEventLogging,
  setGridData,
} from '../store/actions';
import * as CustomErrorMessage from './error_message';
import {
  checkValidDate,
  compareToFutureDate,
  compareTwoDatesGreaterThanOrEqual,
} from '../../../../SharedModules/DateUtilities/DateUtilities';
import CustomSeparator from '../../../../SharedModules/Breadcrumbs/BreadcrumbsComponent';
import { dateFormat } from '../../../../SharedModules/CommonConstants/commonConstants';
import screenName from './Options';
import { ERR_PROCESSING_REQ } from '../../../../SharedModules/AppConstants';
import { cellHead, claimHead, ndcHead, providerHead } from './tableHead';

const initialState = {
  dateRangeOptionStartDate: null,
  dateRangeOptionEndDate: null,
  beginTime: null,
  endTime: null,
  userID: null,
  userLastName: null,
  portletName: 'NDC',
  keyType1: null,
  keyValue1: null,
};

function EventLogging({ location, history }) {
  const [errorMessage, setErrorMessage] = useState([]);
  const dispatch = useDispatch();
  const [redirect, setRedirect] = useState(false);

  const resultData = useSelector(
    (state) => state.sharedState.EventLoggingReducer?.eventLogDetails
  );
  const serviceErr = useSelector(
    (state) => state.sharedState.EventLoggingReducer?.serviceErr
  );
  const spinnerLoader = useSelector((state) => {
    return state?.sharedState.showPreLoader?.showPreLoader;
  });
  const [fieldLevelError, setFieldLevelError] = useState({
    startDate: null,
    endDate: null,
  });

  const [values, setValue] = useState(initialState);
  const handleOnReset = () => {
    setValue(initialState);
    setErrorMessage([]);
    setFieldLevelError({});
  };

  React.useEffect(() => {
    if (serviceErr) {
      setErrorMessage([ERR_PROCESSING_REQ]);
      // setTimeout(() => setErrorMessage([]), 5000);
      dispatch(dispatchServiceFailure(false));
    }
  }, [serviceErr]);

  React.useEffect(()=>{
    setErrorMessage([])
  },[values])

  const dateValidation = (date, event, field) => {
    let startDateError = '';
    let startDateInvalid = false;
    let endDateError = '';
    let isErrored = false;
    const errorMsgs = [];
    const startDate = document.getElementById('begindate-picker-dialog');
    const endDate = document.getElementById('endDate-picker-dialog');
    let startDateValueLength = 0;
    let endDateValueLength = 0;
    // if (startDate?.value) {
    //   startDateValueLength = startDate.value.length;
    // } else {
    //   isErrored = true;
    //   startDateError = CustomErrorMessage.START_DATE_REQUIRED;
    //   errorMsgs.push(CustomErrorMessage.START_DATE_REQUIRED);
    // }
    if (endDate?.value) {
      endDateValueLength = endDate.value.length;
    }
    if (field === 'startDt') {
      if (
        event === 'onBlur' &&
        date.target.value &&
        date.target.value.length > 5
      ) {
        const dateValue = date.target.value.split('/');
        if (dateValue[2].split('_').length === 3) {
          values.dateRangeOptionStartDate = moment(
            date.target.value,
            'MM/DD/YY'
          ).format(dateFormat);
        } else {
          values.dateRangeOptionStartDate =
            date.target.value && date.target.value !== ''
              ? date.target.value
              : null;
        }
      } else {
        values.dateRangeOptionStartDate =
          event === 'onBlur' ? date.target.value : date;
      }
    }
    if (field === 'endDt') {
      if (
        event === 'onBlur' &&
        date.target.value &&
        date.target.value.length > 5
      ) {
        const dateValue = date.target.value.split('/');
        if (dateValue[2].split('_').length === 3) {
          values.dateRangeOptionEndDate = moment(
            date.target.value,
            'MM/DD/YY'
          ).format(dateFormat);
        } else {
          values.dateRangeOptionEndDate =
            date.target.value && date.target.value !== ''
              ? date.target.value
              : null;
        }
      } else {
        values.dateRangeOptionEndDate =
          event === 'onBlur' ? date.target.value : date;
      }
    }
    if (
      values.dateRangeOptionStartDate === 'Invalid date' &&
      startDateValueLength > 0
    ) {
      startDateInvalid = true;
      isErrored = true;
      errorMsgs.push(CustomErrorMessage.INVALID_DATE_FORMAT);
      startDateError = CustomErrorMessage.INVALID_DATE_FORMAT;
    }
    if (
      values.dateRangeOptionEndDate === 'Invalid date' &&
      endDateValueLength > 0
    ) {
      isErrored = true;
      if (!startDateInvalid) {
        errorMsgs.push(CustomErrorMessage.INVALID_DATE_FORMAT);
      }
      endDateError = CustomErrorMessage.INVALID_DATE_FORMAT;
    }
    if (
      !startDateError &&
      values.dateRangeOptionStartDate &&
      !checkValidDate(values.dateRangeOptionStartDate)
    ) {
      isErrored = true;
      errorMsgs.push(CustomErrorMessage.INVALID_DATE_FORMAT);
      startDateError = CustomErrorMessage.INVALID_DATE_FORMAT;
    }
    if (
      !endDateError &&
      values.dateRangeOptionEndDate &&
      !checkValidDate(values.dateRangeOptionEndDate)
    ) {
      isErrored = true;
      errorMsgs.push(CustomErrorMessage.INVALID_DATE_FORMAT);
      endDateError = CustomErrorMessage.INVALID_DATE_FORMAT;
    }
    if (
      !startDateError &&
      !endDateError &&
      values.dateRangeOptionEndDate &&
      endDateValueLength > 0 &&
      values.dateRangeOptionStartDate &&
      compareTwoDatesGreaterThanOrEqual(
        values.dateRangeOptionEndDate,
        values.dateRangeOptionStartDate
      )
    ) {
      isErrored = true;
      errorMsgs.push(CustomErrorMessage.START_DATE_GRETERTHAN_END_DATE);
      endDateError = CustomErrorMessage.START_DATE_GRETERTHAN_END_DATE;
    }

    if (
      !startDateError &&
      values.dateRangeOptionStartDate &&
      compareToFutureDate(new Date(), values.dateRangeOptionStartDate)
    ) {
      isErrored = true;
      errorMsgs.push(CustomErrorMessage.START_DATE_FUTURE_DATE);
      startDateError = CustomErrorMessage.START_DATE_FUTURE_DATE;
    }

    setFieldLevelError({
      ...fieldLevelError,
      endDate: endDateError,
      startDate: startDateError,
    });
    if (errorMsgs.length > 0) {
      setErrorMessage(errorMsgs);
      return isErrored;
    }
    setErrorMessage([]);
    return isErrored;
  };

  const validDate = (d, value, specialCase) => {
    let isValidDate = false;
    if (d === null && specialCase === 'EnteringValue') {
      return true;
    }
    if (specialCase && !value) {
      return false;
    }
    if (Object.prototype.toString.call(d) === '[object Date]') {
      isValidDate = true;

      if (isNaN(d)) {
        isValidDate = false;
      } else {
        isValidDate = true;
      }
    } else {
      isValidDate = false;
    }

    return isValidDate;
  };

  const handleChangeDate = (date, property) => {
    const regex = /[0-9]/g;
    let startDateFromDatePicker = null;
    let startDateFromPickerLength = 0;
    let endDateFromDatePicker = null;
    let endDateFromDatePickerLenght = 0;
    let startDateError = '';
    let startDateErrorMsg = true;

    let errormessageArray = [];
    const startDate = document.getElementById('begindate-picker-dialog');
    const endDate = document.getElementById('endDate-picker-dialog');

    if (property === 'dateRangeOptionStartDate' && date) {
      if (!endDate) {
        errorMessage.push(fieldLevelError.endDate);
      }
      startDateFromDatePicker = moment(date).format('MM/DD/YYYY');
      const startDateArrayFromDatePicker = startDateFromDatePicker.match(regex);
      if (startDateArrayFromDatePicker && startDateArrayFromDatePicker.length) {
        startDateFromPickerLength = startDateArrayFromDatePicker.length;
      }
    }

    if (property === 'dateRangeOptionEndDate' && date) {
      if (!startDate) {
        errorMessage.push(fieldLevelError.startDate);
      }
      endDateFromDatePicker = moment(date).format('MM/DD/YYYY');
      const endDateArrayFromDatePicker = endDateFromDatePicker.match(regex);
      if (endDateArrayFromDatePicker && endDateArrayFromDatePicker.length) {
        endDateFromDatePickerLenght = endDateArrayFromDatePicker.length;
      }
    }

    let startDateValueLength = 0;
    let endDateValueLength = 0;

    if (startDate && startDate.value) {
      const startDateArray = startDate.value.match(regex);
      if (startDateArray && startDateArray.length) {
        startDateValueLength = startDateArray.length;
      }
    }

    if (endDate) {
      const endDateArray = endDate.value.match(regex);
      if (endDateArray && endDateArray.length && endDateArray.length > 0) {
        endDateValueLength = endDateArray.length;
      }
    }

    var val = {
      ...values,
    };
    if (date === null) {
      val[property] = null;
    }
    // can be used for future reference
    // else {
    //   val[property] = moment(date).format('MM/DD/YYYY');
    // }
    setValue(val);

    if (
      property === 'dateRangeOptionStartDate' ||
      property === 'dateRangeOptionEndDate'
    ) {
      if (
        startDateValueLength < 8 &&
        fieldLevelError.startDate === CustomErrorMessage.START_DATE_FUTURE_DATE
      ) {
        startDateError = '';
      }

      if (
        (startDateValueLength === 8 || startDateFromPickerLength === 8) &&
        property === 'dateRangeOptionStartDate' &&
        validDate(
          new Date(values.dateRangeOptionEndDate),
          values.dateRangeOptionEndDate,
          'SpecialCase'
        ) &&
        validDate(date) &&
        compareTwoDatesGreaterThanOrEqual(
          date,
          values.dateRangeOptionEndDate
        ) &&
        !compareTwoDatesGreaterThanOrEqual(new Date(), date)
      ) {
        startDateError = '';
        errormessageArray = [];
        startDateErrorMsg = true;
      }

      if (
        (endDateValueLength === 8 || endDateFromDatePickerLenght === 8) &&
        property === 'dateRangeOptionEndDate' &&
        validDate(
          new Date(values.dateRangeOptionStartDate),
          values.dateRangeOptionStartDate,
          'SpecialCase'
        ) &&
        validDate(date) &&
        compareTwoDatesGreaterThanOrEqual(
          values.dateRangeOptionStartDate,
          date
        ) &&
        !compareTwoDatesGreaterThanOrEqual(
          new Date(),
          values.dateRangeOptionStartDate
        )
      ) {
        startDateError = '';
        errormessageArray = [];
        startDateErrorMsg = true;
      }
    }
    setErrorMessage(errormessageArray);
    setValue({
      ...values,
      [property]: moment(date).format('MM/DD/YYYY'),
    });

    startDateErrorMsg = !(startDateError.length > 0);
    setErrorMessage(errormessageArray);
  };

  useEffect(() => {
    setRedirect(false);
  }, []);

  const handleOnChangeEvent = (e, key) => {
    const { name, value } = e.target;
    if (name) {
      var val = {
        ...values,
      };
      val[name] = value === '' ? null : value;
      setValue(val);
      setErrorMessage([]);
    }
  };

  function areAllValuesEmpty(obj) {
    for (const key in obj) {
      if (
        obj.hasOwnProperty(key) &&
        obj[key] !== '' &&
        obj.hasOwnProperty(key) &&
        obj[key] !== null
      ) {
        return false;
      }
    }
    return true;
  }

  const handleSearch = () => {
    var val = {
      ...values,
    };
    val.beginDate = values.dateRangeOptionStartDate;
    val.endDate = values.dateRangeOptionEndDate;
    delete val.dateRangeOptionStartDate;
    delete val.dateRangeOptionEndDate;

    if (areAllValuesEmpty(val) == true) {
      setErrorMessage(['User ID is required.']);
      dispatch(getEventLogging(''));
    } else if (values.userID == null || values.userID == '') {
      setErrorMessage(['User ID is required.']);
      dispatch(getEventLogging(''));
    } else if (values.keyType1 != null && values.keyValue1 == null) {
      setErrorMessage([
        'Field Value is mandatory when Field Type/Name is selected.',
      ]);
      dispatch(getEventLogging(''));
    } else {
      dispatch(getEventLogging(val))
        .then(() => {
          setErrorMessage([]);
        })
        .catch(() => {});
    }
  };

  const [columnDefs, setColumnDefs] = React.useState([]);

  React.useEffect(() => {
    setColumnDefs(
      values.portletName === 'NDC'
        ? [...cellHead, ...ndcHead]
        : values.portletName === 'Claim' ||
          values.portletName === 'Number Of Units'
        ? [...cellHead, ...claimHead]
        : values.portletName === 'Provider' ||
          values.portletName === 'Ineligible Provider'
        ? [...cellHead, ...providerHead]
        : cellHead
    );
  }, [resultData]);

  return (
    <>
      <div className="tabs-container tBillPanel custom-check">
        <CustomSeparator parent1="System" parent2="Event Logging" />
        {errorMessage === '' ? null : (
          <DisplayErrorMessages errorMessages={errorMessage} />
        )}
        <EvenntLoggingForm
          spinner={spinnerLoader}
          values={values}
          handleOnReset={handleOnReset}
          handleChangeDate={handleChangeDate}
          handleSearch={handleSearch}
          columnDefs={columnDefs}
          handleOnChangeEvent={handleOnChangeEvent}
          gridData={resultData}
          fieldLevelError={fieldLevelError}
          dateValidation={dateValidation}
          screenName={screenName}
        />
      </div>
    </>
  );
}

export default withRouter(EventLogging);
